export default {
    state: {
        apiUrl: '/api'
    }
}
